import config from "../../config"

export abstract class BaseApiRequest {
	protected readonly apiBaseUrl: string
	protected readonly defaultUrl: string


	public constructor(apiBaseUrl: string, defaultPath: string) {
		this.apiBaseUrl = apiBaseUrl;
		this.defaultUrl = apiBaseUrl + defaultPath
	}
}
